<template>
  <v-dialog
    v-model="addSchoolDialog"
    fullscreen
    hide-overlay
    eager
    persistent
    no-click-animation
    transition="slide-x-transition">
    <v-app-bar
      :style="'background-color: ' + appColour"
      :dark="darkToolbar"
      fixed
      v-touch="{ right: () => closeNewSchoolDialog() }">
      <v-btn
        icon
        @click.native="closeNewSchoolDialog()">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title class="ml-0">{{ dialogTitle }}</v-toolbar-title>
      <v-spacer/>
    </v-app-bar>
    <v-content>
      <v-container>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >

          <v-text-field
            v-model="anotherSchoolUser"
            label="User ID"
            required
            :rules="formRules"
          />

          <v-text-field
            :append-icon="showPasswordtext ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="formRules"
            :type="showPasswordtext ? 'text' : 'password'"
            label="Password"
            v-model="anotherSchoolPassword"
            @click:append="showPasswordtext = !showPasswordtext"
          />

          <v-btn
            :disabled="!valid"
            :color="appColour"
            class="mr-4 white--text"
            @click="submitAnotherSchool"
          >
            Submit
          </v-btn>
        </v-form>
        <v-row v-if="alertMsg!=''">
          <v-col class="pa-2 ma-2">
            <v-alert
              :color="alertColor"
              :value="alert"
              class="white--text"
            >
              {{ alertMsg }}
            </v-alert>
          </v-col>

        </v-row>

      </v-container>
    </v-content>
  </v-dialog>
</template>

<script>
export default {
  props: {
    addSchoolDialog: {
      type: Boolean,
      default: false
    },
    reauthentication: {
      type: Boolean,
      default: false
    },
    sharedUserId: {
      type: String,
      default: ''
    }

  },
  data: () => ({
    valid: false,
    anotherSchoolUser: '',
    anotherSchoolPassword: '',
    showPasswordtext: false,
    formRules: [
      v => !!v || 'This field is required'
    ],

    passwordResponseMessage: '',
    responseMessageColourClass: '',
    currentPw: '',
    newPw: '',
    newPwConfirm: '',

    alertMsg: '',
    alertColor: ''

  }),

  computed: {
    darkToolbar () { return this.$store.state.darkToolbar },
    appColour () { return this.$store.state.appColour },
    alert: function () {
      if (this.alertMsg !== '') {
        return true
      } else {
        return false
      }
    },
    dialogTitle: function () {
      if (this.reauthentication === true && this.sharedUserId !== '') {
        return 'Re-enter Password'
      } else {
        return 'Add New School'
      }
    }
  },

  created: function () {
    if (this.reauthentication === true && this.sharedUserId !== '') {
      this.anotherSchoolUser = this.sharedUserId
    }
  },
  methods: {
    closeNewSchoolDialog () {
      this.passwordResponseMessage = ''
      this.$refs.form.reset()
      this.$emit('closednewschool')
    },

    submitAnotherSchool () {
      if (this.$refs.form.validate()) {
        this.$store.commit('loading', true)
        var obj = { mainUserId: this.$store.state.userId, anotherUserId: this.anotherSchoolUser, anotherPassword: this.anotherSchoolPassword, school: this.$store.state.schoolId }

        if (this.reauthentication) {
          var reauthenticateData = JSON.stringify(obj)

          this.$http.post('/reAuthenticateSharedSchool', {
            'anotherSchoolDetails': reauthenticateData
          })
            .then(resp => {
              this.$store.commit('loading', false)

              this.alertColor = resp.data.colourMessage
              this.alertMsg = resp.data.message

              if (resp.data.message.includes('successfully')) {
                this.$refs.form.reset()
              }
            })
        } else {
          var addnewschooldata = JSON.stringify(obj)

          this.$http.post('https://www.atschool.co.nz/api/v2/addNewSchool', {
            'anotherSchoolDetails': addnewschooldata
          })
            .then(resp => {
              this.$store.commit('loading', false)

              this.alertColor = resp.data.colourMessage
              this.alertMsg = resp.data.message

              if (resp.data.message.includes('successfully')) {
                this.$refs.form.reset()
              }
            })
        }
      }
    }

  }
}
</script>

<style scoped>
/* Change dialog background to white, so that it covers the bottom part which was visible */
.v-dialog__content--active {
  background-color: white;
}
</style>
